export default "__VITE_ASSET__B6dqD_E9__"